import { schema } from 'normalizr';
import { IEntity } from '@core/state/entities/entity';
import {
  FurtherStudyDetails,
  UserInclusionFilter,
} from '@core/services/api-client.generated';

export interface IStageStudyInfo {
  stageId: string;
  outcomeData: boolean;
  annotationStatus: annotationStatus;
}

export enum annotationStatus {
  NotStarted,
  NotAvailable,
  InProgress,
  Completed,
}

const notStarted = 'Not Started';
const notAvailable = 'Not Available';
const inProgress = 'In Progress';
const completed = 'Completed';

type notStarted = 'Not Started';
type notAvailable = 'Not Available';
type inProgress = 'In Progress';
type completed = 'Completed';

export type AnnotationStatus =
  | notStarted
  | notAvailable
  | inProgress
  | completed;

export const annotationStatuses: { [index: number]: AnnotationStatus } = {
  0: notStarted,
  1: notAvailable,
  2: inProgress,
  3: completed,
};

export interface IStudyDetails extends IEntity, FurtherStudyDetails {

}

export const studyDetailsSchema = new schema.Entity('studyDetails');
